const throughVert = `
varying vec2 vUv;
varying vec3 vWorldPos;
varying float vViewDist;

void main()	{
  vUv = uv;
  vec4 worldPosition = modelMatrix * vec4( position, 1.0 );
  vWorldPos = worldPosition.xyz;
  vViewDist = distance(cameraPosition, worldPosition.xyz);
  gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}
`;
export default throughVert;

